import { RocheUIOverline } from '@repo/roche-ui';
import React, { FC } from 'react';
import { BlokToComponentProps } from '../../helpers/blok-to-component/types';

type RocheOverlineProps = BlokToComponentProps<{
  overline_text: string;
}>;

export const RocheOverline: FC<RocheOverlineProps> = ({ blok, slot }) => {
  return <RocheUIOverline overlineText={blok.overline_text} slot={slot} />;
};
